/**
 * 离职员工相关接口
 * @date 2024-8-20
 * @Author: GuanHanTao
 */
import request from "@/utils/request";

// 离职原因列表
export function leave_reason(params) {
    return request({
        url: '/system/dict/data/type/leave_reason',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 获取打卡情况
export function getCheckInInfo(params) {
    return request({
        url: '/system/checkin/getCheckInInfo',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}
// 获取请假情况
export function getLeaveInfo(params) {
    return request({
        url: '/work/leave/getLeaveInfo',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}


